export default {
      id: "ar_portail_familles-usage",
      viewBox: "0 0 90 75",
      url: "../dist/images/" + "sprite.svg#ar_portail_familles-usage",
      toString: function () {
        return this.url;
      }
    }